const de = require("../locales/de.json");
const en = require("../locales/en.json");
const tr = require("../locales/tr.json");

export const dictionaries = {
  de: { ...de },
  en: { ...en },
  tr: { ...tr },
};
